import { render, staticRenderFns } from "./myPrescriptionIndex.vue?vue&type=template&id=cd28bb08&scoped=true&"
import script from "./myPrescriptionIndex.vue?vue&type=script&lang=js&"
export * from "./myPrescriptionIndex.vue?vue&type=script&lang=js&"
import style0 from "./myPrescriptionIndex.vue?vue&type=style&index=0&id=cd28bb08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd28bb08",
  null
  
)

export default component.exports